import { LinearProgress, styled, Typography as TypographyMui } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
const Typography = styled(TypographyMui)({
    textAlign: 'left',
    fontWeight: '500',
    fontSize: '15px',
    color: '#000',
    '& + .MuiTypography-root': {
        marginTop: '8px'
    }
});
const useStyles = makeStyles()(theme => {
    return {
        betaWithoutLable: {
            top: '-2px !important',
            right: '-8px !important'
        }
    };
});
const COUNTDOWN_SECONDS = 5;
const BetaItem = ({ showLabel }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const [betaActive, setBetaActive] = useState(true);
    const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
    const _classes = `beta-item ${!showLabel ? '' : classes.betaWithoutLable}`;
    useEffect(() => {
        setTimeout(() => {
            setBetaActive(false);
        }, 5500);
    }, []);
    useEffect(() => {
        if (!betaActive)
            return;
        const interval = setInterval(() => {
            setSecondsLeft(prev => {
                if (prev < 0.5) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 0.25;
            });
        }, 250);
        return () => clearInterval(interval);
    }, [betaActive]);
    // Tính phần trăm cho CircularProgress
    const progress = (secondsLeft / COUNTDOWN_SECONDS) * 100;
    return (React.createElement("span", { className: `${_classes} ${betaActive ? 'beta-active' : ''}` },
        React.createElement("span", { className: 'beta-text' }, "Beta"),
        React.createElement("span", { className: 'beta-content' },
            React.createElement(Typography, null, t('beta.closedCaption-1'))),
        (secondsLeft > 0.2 && betaActive) && React.createElement(LinearProgress, { variant: 'determinate', sx: {
                position: 'absolute',
                top: -36,
                left: -44,
                right: -220,
                borderRadius: 6,
                backgroundColor: 'transparent',
                '& > span': {
                    background: 'linear-gradient(90deg, rgba(155, 42, 151, 1) 0%, rgba(87, 121, 199, 1) 50%, rgba(237, 83, 83, 1) 100%)'
                }
            }, value: progress })));
};
export default BetaItem;
